import React from 'react';
import PropTypes from 'prop-types';
import {AppProvider, Navigation, Button} from '@shopify/polaris';
import { 
  HomeMajorTwotone, ProductsMajorTwotone, ListMajorTwotone, InventoryMajorTwotone, OrdersMajorTwotone, 
  CircleInformationMajorMonotone, CustomerMinusMajorTwotone, AnalyticsMajorMonotone, PackageMajorMonotone, 
  BlogMajorMonotone, BalanceMajorMonotone
} from '@shopify/polaris-icons';
import translations from '@shopify/polaris/locales/es.json';

const propTypes = {
  urls_navigation: PropTypes.array.isRequired,
  urls_navigation_admin: PropTypes.array.isRequired,
  currentLocation: PropTypes.string.isRequired,
}

const iconsName= {
  home: HomeMajorTwotone,
  products: ProductsMajorTwotone,
  list: ListMajorTwotone,
  inventory: InventoryMajorTwotone,
  orders: OrdersMajorTwotone,
  warranty: CircleInformationMajorMonotone,
  users: CustomerMinusMajorTwotone,
  analytics: AnalyticsMajorMonotone,
  returns: PackageMajorMonotone,
  forms: BlogMajorMonotone,
  balance: BalanceMajorMonotone,
}

class SidebarWrapper extends  React.Component {
  constructor(props){
    super(props);
    const sidebarLinks = this.buildLinks(props.urls_navigation); // done this so can console.log when debugging easily
    const sidebarAdmin = this.buildLinks(props.urls_navigation_admin);
    this.state = {
      sidebarNavigation: sidebarLinks,
      setMobile: false,
      sidebarNavigationAdmin: sidebarAdmin,
    }
  }

  // Set explicit selected value or return undefined/null to keep the default behavior (this is for individual items)
  setSelected = (label, url) => {
    // console.log("Label/URL", label, url)
    const urlWeb = window.location.href // Manually set the url come from web
    switch(label){
      case "Menu":
        return (urlWeb.includes("links"))
      case "Banners":
        return (urlWeb.includes("banners"))
      case "Entregas":
        return (urlWeb.includes("transfers")) && !(urlWeb.includes("payments")) // temporal workaround when accessing payments views which are nested like "transfers/payments", "/transfers" path is highlighted as well
      default:
        return undefined
    }
  }

  buildLinks = (linksData) => {
    return linksData.map( itemData => {

      const subNavigationItems = itemData.submenu.map(subLink => {
        const selected = this.setSelected(subLink.label, subLink.url); // true/false or undefined(to keep URL default auto selected)
        return {
          url: subLink.url,
          label: subLink.label,
          icon: iconsName[subLink.icon],
          selected: selected,
          matches: selected, // if true Submenu will be expanded!
        }
      });

      // Build basic item
      let linkItem = {
        url: itemData.url,
        label: itemData.label,
        icon: iconsName[itemData.icon],
        subNavigationItems: subNavigationItems, // [] if none
      };

      if(linkItem.subNavigationItems.length > 0){ // For items with submenus, only highlight if any item is selected (this allow for use of subpaths outside of a group). i.e. "/transfers/payments" should highlight "Pagos" BUT not "Inventario APU" menu with subitems
        const anySelected = linkItem.subNavigationItems.some(subItem => subItem.selected);
        linkItem.selected = anySelected;
      }

      return linkItem;
    });
  }

  toggleSidebarMenu=()=>{
    this.setState(({setMobile})=>({setMobile: !setMobile}));
  };

  render(){
    return (
      <AppProvider theme={{
          UNSTABLE_colors: {
            surface: '#00b6e0',
            darkSurface: '#00b6e0',
            onSurface: '#00b6e0',
            interactive: '#00b6e0',
            neutral: '#00b6e0',
            branded: '#00b6e0',
            critical: '#00b6e0',
            warning: '#00b6e0',
            highlight: '#00b6e0',
            success: '#00b6e0',
          }
        }}
        i18n={translations}
      >
        <div className={`${this.state.setMobile ? "showMobil" : "noMobil"}`}>
          <Button icon={`${this.state.setMobile ? "cancel" : "menu"}`} onClick={this.toggleSidebarMenu} className={"ok"}></Button>
          <Navigation location={ this.props.currentLocation } >
            <Navigation.Section items={this.state.sidebarNavigation} />
          
            <Navigation.Section
              title= {(this.state.sidebarNavigationAdmin.length > 0) ? "Admin" : ""}
              items={this.state.sidebarNavigationAdmin}
              separator
            />
          </Navigation>
        </div>
      </AppProvider>
    );
  }
}

SidebarWrapper.propTypes =  propTypes;

export  default SidebarWrapper;
